module.exports = __webpack_public_path__ + "static/media/Saudi Arabia.e7f4cf48.png";